import { render, staticRenderFns } from "./AppWrapperDiv.vue?vue&type=template&id=70b49be6"
import script from "./AppWrapperDiv.vue?vue&type=script&lang=js"
export * from "./AppWrapperDiv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports